export const joinPath = (base, segment) => {
  return `${base.replace(/\/+$/, '')}/${segment.replace(/^\/+/, '')}`;
}
